const config = {
    baseURL: 'https://cfobridge.com/uae',
    imageBaseURL: '',
    paths: {
        banners: '/banners/',
        teams: '/teams/',
        images: '/images/',
        img: '/img/',
        testimonials: 'https://cfobridge.com/uploads/images/'
    }
};

export default config; 